var _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilePictures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 120h-88c-1.104 0-2-0.9-2-2v-88.088c0-0.512 0.196-1.004 0.548-1.376l26.456-27.912c0.376-0.4 0.904-0.624 1.452-0.624h61.544c1.1 0 2 0.896 2 2v116c0 1.1-0.9 2-2 2zM18 116h84v-112h-58.684l-25.316 26.708v85.292z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32h-26c-1.104 0-2-0.896-2-2s0.896-2 2-2h24v-24c0-1.104 0.896-2 2-2s2 0.896 2 2v26c0 1.104-0.896 2-2 2z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 104h-56c-1.104 0-2-0.9-2-2v-56c0-1.104 0.896-2 2-2h56c1.1 0 2 0.896 2 2v56c0 1.1-0.9 2-2 2zM34 100h52v-52h-52v52z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96h-52c-1.104 0-2-0.9-2-2s0.896-2 2-2h52c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.724 84c-0.024 0-0.052 0-0.080 0h-30.624c-0.788 0-1.504-0.464-1.828-1.184-0.324-0.724-0.188-1.568 0.336-2.152l8.28-9.22c0.584-0.648 1.512-0.844 2.308-0.484l4.752 2.132 7.152-8.084c0.432-0.496 1.088-0.748 1.748-0.66 0.656 0.080 1.228 0.48 1.528 1.064l7.9 15.232c0.332 0.356 0.536 0.832 0.536 1.356-0.008 1.1-0.904 2-2.008 2zM48.5 80h22.848l-5.268-10.156-6.192 6.996c-0.58 0.66-1.516 0.86-2.316 0.5l-4.76-2.136-4.312 4.796z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.268 69c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM50.268 59c-1.656 0-3 1.344-3 3s1.344 3 3 3 3-1.344 3-3-1.348-3-3-3z",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePictures);
export default __webpack_public_path__ + "static/media/File-Pictures.bc6f9f16.svg";
export { ForwardRef as ReactComponent };